module.exports = __webpack_public_path__ + "static/media/logomarca.99227b68.png";